import React, { useEffect, useState } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { useLoading } from 'src/hooks/useLoading';

export const GlobalLoadingIndicator = () => {
  const { isLoading } = useLoading();
  const [isFullified, setIsFullified] = useState(true);

  useEffect(() => {
    if (isLoading && isFullified) {
      setIsFullified(false);
    }
  }, [isLoading, isFullified]);

  return (
    <div className='fixed z-50 flex w-full justify-center'>
      <div
        className={twJoin(
          'h-1 w-full overflow-hidden',
          !isFullified && 'bg-layout',
        )}
      >
        <div
          className={twMerge(
            'left-right left-right h-full w-0 bg-loading transition-all duration-1000',
            isLoading
              ? 'w-5/6'
              : isFullified
                ? 'transition-none'
                : 'w-full duration-200',
          )}
          onTransitionEnd={() => !isLoading && setIsFullified(true)}
        ></div>
      </div>
    </div>
  );
};
